import { useTranslation } from "react-i18next"
import styles from "./HeroImage.module.css"
import { Tooltip } from "antd"
import { Icon } from "ui/Icon"

export const HeroImage = () => {
  const { t } = useTranslation()
  return (
    <Tooltip placement="bottom" title={t("listings.tabs.media.heroImageDescription")}>
      <div className={styles.heroImage}>
        <Icon width={18} height={18} name="Info" color="currentColor" />
        <div>{t("listings.tabs.media.heroImage")}</div>
      </div>
    </Tooltip>
  )
}
